import { AnimatePresence, m } from "framer-motion";
import { Menu, X } from "lucide-react";

interface MobileMenuButtonProps {
	isOpen: boolean;
	onToggle: () => void;
	/** Tailwind visibility class controlling when the button shows. Defaults to "lg:hidden". */
	visibilityClass?: string;
}

export function MobileMenuButton({
	isOpen,
	onToggle,
	visibilityClass = "lg:hidden",
}: MobileMenuButtonProps) {
	return (
		<button
			type="button"
			onClick={onToggle}
			className={`${visibilityClass} relative flex items-center justify-center size-8 border border-border bg-background text-muted-foreground transition-[color,border-color,transform] hover:border-brand/40 hover:text-brand active:scale-[0.96] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-background before:absolute before:-inset-[6px] before:content-['']`}
			aria-label={isOpen ? "Close menu" : "Open menu"}
			aria-expanded={isOpen}
		>
			<AnimatePresence initial={false} mode="wait">
				{isOpen ? (
					<m.div
						key="close"
						initial={{ scale: 0.25, opacity: 0, filter: "blur(4px)" }}
						animate={{ scale: 1, opacity: 1, filter: "blur(0px)" }}
						exit={{ scale: 0.25, opacity: 0, filter: "blur(4px)" }}
						transition={{ type: "spring", duration: 0.3, bounce: 0 }}
					>
						<X className="size-4" />
					</m.div>
				) : (
					<m.div
						key="menu"
						initial={{ scale: 0.25, opacity: 0, filter: "blur(4px)" }}
						animate={{ scale: 1, opacity: 1, filter: "blur(0px)" }}
						exit={{ scale: 0.25, opacity: 0, filter: "blur(4px)" }}
						transition={{ type: "spring", duration: 0.3, bounce: 0 }}
					>
						<Menu className="size-4" />
					</m.div>
				)}
			</AnimatePresence>
		</button>
	);
}
